import { z } from 'zod';
import { ErrorResponseSchema } from './errors';
export const RoleTemplateSchema = z.object({
    id: z.string(),
    title: z.string(),
    description: z.string(),
    created_at: z.string(),
    updated_at: z.string(),
    deleted_at: z.string().nullable(),
});
export const RoleTemplatesResponseSchema = z.object({
    type: z.literal('success'),
    data: z.array(RoleTemplateSchema),
});
export const RoleTemplateResponseSchema = z.object({
    type: z.literal('success'),
    data: RoleTemplateSchema,
});
// Union type for role templates API responses
export const RoleTemplatesApiResponseSchema = z.discriminatedUnion('type', [
    RoleTemplatesResponseSchema,
    ErrorResponseSchema,
]);
export const RoleTemplateApiResponseSchema = z.discriminatedUnion('type', [
    RoleTemplateResponseSchema,
    ErrorResponseSchema,
]);
// ===== CREATE ROLE TEMPLATE SCHEMAS =====
export const CreateRoleTemplateRequestSchema = z.object({
    title: z.string().min(1, 'Title is required'),
    description: z.string().min(1, 'Description is required'),
});
export const CreateRoleTemplateSuccessResponseSchema = z.object({
    type: z.literal('success'),
    data: z.object({
        message: z.string(),
        roleTemplate: RoleTemplateSchema,
    }),
});
export const CreateRoleTemplateResponseSchema = z.discriminatedUnion('type', [
    CreateRoleTemplateSuccessResponseSchema,
    ErrorResponseSchema,
]);
// ===== SOFT DELETE ROLE TEMPLATE SCHEMAS =====
// Soft delete role template request schema
export const SoftDeleteRoleTemplateRequestSchema = z.object({
    id: z.uuid(),
});
// Soft delete role template success response schema
export const SoftDeleteRoleTemplateSuccessResponseSchema = z.object({
    type: z.literal('success'),
    data: z.object({
        message: z.string(),
        deletedTemplateId: z.string(),
    }),
});
// Soft delete role template response schema (union type)
export const SoftDeleteRoleTemplateResponseSchema = z.discriminatedUnion('type', [SoftDeleteRoleTemplateSuccessResponseSchema, ErrorResponseSchema]);
